export default {
    blue: '#457bbd',
    darkBlue: '#445161',
    green: '#50ad55',
    carsGreen: '#93a533',
    red: '#d0011b',
    pink: '#fc365a',
    yellow: '#FFED0D',
    carsLightPurple: '#a400b4',
    carsPurple: '#250858',
    carsLightBlue: 'rgba(0, 77, 129, 0.1)',
    carsDarkBlue: 'rgba(0, 77, 129, 1)',

    // grays
    white: '#fefefe',
    lightGray: '#f2f2f2',
    mediumLightGray: '#e6e7ed',
    mediumGray: '#d8d8d8',
    mediumDarkGray: '#9a9a9a',
    darkGray: '#6f7479',
    extraDarkGray: '#4a4a4a',
    black: '#333333',
    carsGray: '#3a4951',
};



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/colors.ts